export const generateStudentId = () => {
  const n = Math.floor(1 + Math.random() * 999999);

  return "STS" + String(n).padStart(6, "0");
};